import type { HistogramTooltipDataPoint } from '../../components/overlays/utils/bins-to-tooltip.js';
import type { HistogramChartState } from '../../types/state.js';

export function reduceClosestBins(
  prev: HistogramChartState,
  closestBins?: {
    closestBin: HistogramTooltipDataPoint;
    closestBinsGrouped: HistogramTooltipDataPoint[][];
    closestBinsByVariant: HistogramTooltipDataPoint[];
  },
): HistogramChartState {
  return {
    ...prev,
    closestBins,
  };
}
